import { createFileRoute } from "@tanstack/react-router";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import {
  SERVICES_DATA,
  SLUG_ALIASES,
  type ServiceDetail,
} from "@/data/servicesData";
import { buildHead, SITE_URL } from "@/lib/seo-head";

function resolveService(slug: string | undefined) {
  if (!slug) return null;
  const targetSlug = SLUG_ALIASES[slug] || slug;
  const service = targetSlug ? SERVICES_DATA[targetSlug] : null;
  return service ? { service } : null;
}

export const Route = createFileRoute("/services/$slug")({
  head: ({ loaderData }) => {
    const data = loaderData as unknown as { service: ServiceDetail } | null;
    if (!data) {
      return buildHead({
        title: "Service Not Found | Abacus Design Solutions",
        description:
          "The service page you are looking for does not exist or has been moved.",
        path: "/services",
        noIndex: true,
      });
    }
    const s = data.service;
    const title = `${s.seoTitle || s.title} | Abacus Design Solutions`;
    const description = s.seoDescription || s.description;
    return buildHead({
      title,
      description,
      path: `/services/${s.slug}`,
      ogImage: s.heroImage,
      schemaJson: {
        "@context": "https://schema.org",
        "@type": "Service",
        name: s.title,
        description: s.description,
        url: `${SITE_URL}/services/${s.slug}`,
        provider: {
          "@type": "Organization",
          name: "Abacus Design Solutions",
          url: SITE_URL,
        },
      },
    });
  },
  loader: ({ params }) => resolveService(params.slug),
  component: ServiceDetailPage,
});
